import { Injectable } from "@angular/core";

import { DurationSearchCriteria } from "@models/DurationSearchCriteria";

import { PlantsService } from "./plants.service";

@Injectable()
export class DurationSearchResolver {
  constructor(private ps: PlantsService) {}

  async resolve(): Promise<DurationSearchCriteria> {
    const criteria = await this.ps.getDurationSearchCriteria();
    return criteria;
  }
}
